import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  async readExcel(evt: any, cb: any): Promise<void> {
    const target: DataTransfer = (evt.target) as DataTransfer;
    if (target.files.length !== 1) {
      return;
    }

    const file = target.files[0];
    const workbook = new ExcelJS.Workbook();
    
    try {
      await workbook.xlsx.read(file);
      const worksheet = workbook.getWorksheet(1);
      const jsonData: any[] = [];
      
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1) return;
        const rowData: any = {};
        worksheet.getRow(1).eachCell((cell, colNumber) => {
          rowData[cell.text] = row.getCell(colNumber).text;
        });
        jsonData.push(rowData);
      });
      
      cb(jsonData);
    } catch {
      cb([]);
    }
  }

  async exportAsExcelFile(json: any[], excelFileName: string): Promise<void> {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('data');

    if (json.length > 0) {
      const headers = Object.keys(json[0]);
      const headerRow = worksheet.addRow(headers);

      headerRow.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF538da5' }
        };
        cell.font = {
          bold: true,
          color: { argb: 'FFFFFFFF' }
        };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

      json.forEach((record) => {
        const row = headers.map(header => record[header]);
        const dataRow = worksheet.addRow(row);
        
        dataRow.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        });
      });

      worksheet.columns.forEach((column) => {
        let maxLength = 10;
        column.eachCell?.({ includeEmpty: true }, (cell) => {
          const cellLength = cell.value?.toString().length || 0;
          if (cellLength > maxLength) {
            maxLength = cellLength;
          }
        });
        column.width = Math.min(maxLength + 2, 50);
      });
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${excelFileName}.xlsx`;
    link.click();
    window.URL.revokeObjectURL(url);
  }
}
